'use strict';

module.exports = (items, dealUuid, optionUuid) => {
  if (!items || !dealUuid || !optionUuid) return null;
  const deal = items.find(item => item.dealUuid === dealUuid);
  if (!deal || !deal.options) return null;
  const dealOption = deal.options.find(option => option.uuid === optionUuid);
  return dealOption.minimumPurchaseQuantity;
};
